module.exports = __webpack_public_path__ + "assets/img/de-e95d9d6a.png";